<template>
    <form :id="id" @submit.prevent="handleSubmit">
        <fieldset :disabled="disabled">
            <x-form-group
                label="ID"
                v-if="fields.display_name"
                :horizontal="false"
            >
                <input
                    type="text"
                    class="form-control"
                    v-model="fields.display_name"
                    disabled
                />
            </x-form-group>

            <x-form-group
                label="File"
                :error="getError('file')"
                :is-required="allowFileUpload"
                :horizontal="false"
            >
                <input
                    v-if="allowFileUpload"
                    type="file"
                    class="form-control"
                    accept="application/pdf"
                    @change="handleFileChange"
                    required
                />
                <div v-if="!allowFileUpload">
                    <a :href="fields.file_url" target="_blank">
                        {{ fields.file_path }}
                    </a>
                </div>
            </x-form-group>

            <x-form-group
                label="Page Start"
                :horizontal="false"
                :isRequired="true"
            >
                <input
                    type="number"
                    class="form-control"
                    v-model="fields.page_start"
                    required
                />
            </x-form-group>

            <x-form-group
                label="Page End"
                :horizontal="false"
                helpText="Kosongkan bila tidak ada batasan halaman"
            >
                <input
                    type="number"
                    class="form-control"
                    v-model="fields.page_end"
                    placeholder="Sampai Akhir Halaman"
                />
            </x-form-group>
        </fieldset>
    </form>
</template>

<script>
import XFormGroup from "../../components/XFormGroup.vue";
import FormDataMixin from "../../mixins/FormDataMixin";
import FormErrorMixin from "../../mixins/FormErrorMixin";
import PropertySyncMixin from "../../mixins/PropertySyncMixin";

export default {
    components: {
        XFormGroup,
    },
    computed: {
        allowFileUpload() {
            return !this.initialFields.file_path;
        },
    },
    created() {
        this.fields = {
            ...this.fields,
            ...this.initialFields,
        };
        this.initialStatus = this.fields.status;
    },
    data() {
        return {
            fields: {
                display_name: null,
                file_path: null,
                file_url: null,
                page_start: 1,
                page_end: null,
            },
            isLoading: false,
            selectedFile: null,
        };
    },
    methods: {
        handleFileChange(event) {
            this.selectedFile = event.target.files[0];
        },
        handleSubmit() {
            const formData = this.buildFormData({
                file: this.selectedFile,
                page_start: this.fields.page_start,
                page_end: this.fields.page_end,
            });
            this.$emit("submit", formData);
        },
    },
    mixins: [FormDataMixin, FormErrorMixin, PropertySyncMixin],
    props: {
        disabled: {
            type: Boolean,
            required: false,
            default: false,
        },
        errors: {
            type: Object,
            required: false,
            default: null,
        },
        id: {
            type: String,
            required: false,
            default: null,
        },
        initialFields: {
            type: Object,
            required: false,
            default: () => ({}),
        },
        readonly: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
};
</script>
